import axios from 'axios'
import create from 'zustand'
import { persist } from 'zustand/middleware'
import Cookies from 'js-cookie'

//#region cohort store
let store = (set) => ({
  // store cohorts
  cohorts: {},
  cohortCount: 0,
  // get All cohorts
  getCohorts: async () => {
    // setting token
    let token = Cookies.get('token')

    // attach token to header
    // sort and order data by which column and how
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
      params: {
        sortBy: 'cohort.id',
        orderBy: 'desc',
      }
    }
    // setting url 
    // main url comes from .env file
    const apiResponse = await axios.get(`${process.env.REACT_APP_API}/cohort`, config)
    set(async (state) => {
      // initilize cohorts state variable to the responsed cohorts if request succeed
      if (apiResponse?.status == 200 || apiResponse?.status == 201)
        state.cohorts = apiResponse.data
    })
  },
  getCohortCount: async () => {
    // setting token
    let token = Cookies.get('token')

    // attach token to header
    // sort and order data by which column and how
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      }
    }
    // setting url 
    // main url comes from .env file
    const apiResponse = await axios.get(`${process.env.REACT_APP_API}/cohort/getcount`, config)
    set(async (state) => {
      // initilize cohorts state variable to the responsed cohorts if request succeed
      if (apiResponse?.status == 200 || apiResponse?.status == 201)
        state.cohortCount = apiResponse?.data?.cohort ?? ''
    })
  },
  addCohort: async (payload) => {
    // setting token
    let token = Cookies.get('token')

    // attaching token to the header
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }

    // setting url 
    // main url comes from .env file 
    const apiResponse = await axios.post(`${process.env.REACT_APP_API}/cohort`, payload, config)
    if (apiResponse?.status === 201) {
      set(async (state) => {
        // initilizing cohorts state variable to the resoponsed data
        state.cohorts = {
          data: [apiResponse.data, ...state.cohorts.data],
          limit: state.cohorts.limit,
          page: state.cohorts.page,
          totalCount: state.cohorts.totalCount + 1,
        }
      })
    }
    return apiResponse
  },
  editCohort: async (payload, id) => {
    // setting token
    let token = Cookies.get('token')

    // attaching token to the header
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }

    // setting url 
    // main url comes from .env file 
    const apiResponse = await axios.patch(`${process.env.REACT_APP_API}/cohort/${id}`, payload, config)
    // update cohorts state variable if update request was succeed
    if (apiResponse?.status === 200) {
      set(async (state) => {
        const result = state.cohorts?.data?.find((cohort, index) => {

          if (cohort.id === id) {
            state.cohorts.data[index] = apiResponse?.data
          }
        })

        state.cohorts = {
          data: [...state.cohorts.data],
          limit: state.cohorts.limit,
          page: state.cohorts.page,
          totalCount: state.cohorts.totalCount,
        }
      })
    }
    return apiResponse
  },
  deleteCohort: async (id) => {
    // setting token
    let token = Cookies.get('token')

    // attaching token to the header
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }
    // setting url 
    // main url comes from .env file 
    const apiResponse = await axios.delete(`${process.env.REACT_APP_API}/cohort/${id}`, config)
    // delete element in the cohorts.data array state if the request was succeed
    if (apiResponse?.status === 200 || apiResponse?.status === 201) {

      set(async (state) => {
        const arr = state.cohorts.data.filter(item => item.id !== id)
        state.cohorts = {
          data: arr,
          limit: state.cohorts.limit,
          page: state.cohorts.page,
          totalCount: state.cohorts.totalCount - 1,
        }
      })

    }

    return apiResponse

  },
})
//#endregion cohort store

// store the state in the browser local storage
// store = persist(store, { name: 'cohort' })

// getting store data in the browser localstorage
const cohort_Store = create(store)

export default cohort_Store
